import { DictionaryObject } from '@cawita/core-front';
import { ApiData } from '@cawita/core-front/api';
import { CwtModel } from '@shared/modules/crud';
import { Address } from './address.model';
import { Document } from './document.model';
import { Picto } from './picto.model';
import { Region } from './region.model';
import { User } from './user.model';

export enum PartnerFeature {
    FlashAndKatch = 'isFlashAndKatchActive',
    Activity = 'isActivityActive',
    Report = 'isReportActive',
    UserActivityCreation = 'isUserActivityCreationActive'
}

@CwtModel({ name: 'partner', path: '/partner' })
export class Partner extends ApiData {
    name?: DictionaryObject;
    address?: Address;
    phone?: string;
    email?: string;
    pictures?: PartnerDocument[];
    documents?: PartnerDocument[];
    map?: PartnerDocument;
    description?: DictionaryObject;
    managers?: User[];
    generalInfo?: string;
    wristbandUsed?: boolean;
    subtitle?: string;
    isFlashAndKatchActive?: boolean;
    isActivityActive?: boolean;
    isReportActive?: boolean;
    isUserActivityCreationActive?: boolean;
    region?: Region;
    url?: string;
    callCenterPhone?: string;
    clientSpaceUrl?: string;
    picto?: Picto[];
    presentationPictures?: Document[];
    useOwnerPassport?: boolean;
    isLocationActive?: boolean;

    public get uiLogo(): PartnerDocument { return this.pictures?.find(p => p?.type === 'logo'); }
}

export interface PartnerDocument extends Document {
    name?: DictionaryObject;
    description?: DictionaryObject;
}
